import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import {
  Button,
  NewsCard,
  NewsGroup,
  TrendingNewsCard,
} from "../../../../components";
import { withRouter } from "react-router-dom";
import { getAllPastNews } from "../../../news/service/news.service";
import { getLanguage } from "../../../../utils/environment";

import {
  HomePageCenterAdd,
  NewsHomeBottomAdd,
} from "../../../templates/advertiesments";

// const categoryId = process.env.REACT_APP_MAIN_NEWS;
// const categoryId = process.env.REACT_APP_HOT_NEWS;
const pageCount = process.env.REACT_APP_MAIN_P_COUNT;
const language = getLanguage();

const Index = (props) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [news, setNews] = React.useState([]);
  const [menu, setMenu] = React.useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [loadingMore, setLoadingMore] = React.useState(false);
  const [hasMore, setHasMore] = useState(true);

  const fetchNews = async () => {
    if (props.active && news?.length === 0) {
      try {
        const response = await getAllPastNews(language, pageNo, pageSize);
        console.log("response getAllPastNews::", response);

        if (response?.data) {
          setNews(response?.data?.past_news);
          setPageNo(2); // Set the next page number for loading more news
          setHasMore(response?.data?.past_news.length >= pageSize);
        } else {
          console.error("No data found in past news");
          setHasMore(false);
        }

        setIsLoading(false);
      } catch (error) {
        console.log({ error });
        setIsLoading(false);
      }
    }
  };

  const loadMoreNews = async (pageNo) => {
    if (isLoading || !hasMore) return; // Prevent multiple requests while loading or if no more news
    setLoadingMore(true);
    try {
      const response = await getAllPastNews(language, pageNo, pageSize);
      // console.log("response getAllPastNews::", response);

      if (response?.data?.past_news?.length > 0) {
        const newNews = response?.data?.past_news || [];
        // setNews((prevNews) => [...prevNews, ...newNews]);
        setNews((prev) => {
          const existingIds = new Set(prev.map((n) => n.news_id));
          const filtered = newNews.filter((n) => !existingIds.has(n.news_id));
          return [...prev, ...filtered];
        });
        setPageNo((prev) => prev + 1);
        setHasMore(newNews.length >= pageSize);
        setLoadingMore(false);
        setIsLoading(false);
      } else {
        console.error("No data found in past news");
        setHasMore(false);
        setLoadingMore(false);
        setIsLoading(false);
      }
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
      setLoadingMore(false);
    }
  };

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (
  //       window.scrollY >=
  //         document.documentElement.scrollHeight - window.innerHeight - 100 &&
  //       hasMore
  //     ) {
  //       setLoadingMore(true);
  //       loadMoreNews(pageNo);
  //       // console.log("Scroll position:", window.scrollY);
  //     }
  //   };
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [pageNo, hasMore]);

  useEffect(() => {
    if (props.active && news?.length === 0) {
      setIsLoading(true);
      fetchNews();
    }
  }, [language && props.active]);

  return (
    <>
      <NewsGroup
        data={{
          titleName: "All News",
          linkName: "",
        }}
      >
        {!isLoading &&
          news.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <NewsCard
                  key={index}
                  data={{
                    type: "extrasmall",
                    isBorder: true,
                    isUpdate: false,
                  }}
                  item={item}
                  onClick={() => {
                    if (item?.keywords?.[language]) {
                      props.history.push(
                        `/${item?.keywords?.[language]}/${item?.news_id}`
                      );
                    } else {
                      const generatedSlug = item?.title?.[language]
                        ?.replace(/[\u200B-\u200D\uFEFF]/g, "")
                        ?.replace(/\//g, "")
                        ?.replace(/\s*-\s*/g, " ")
                        ?.trim()
                        .split(/\s+/)
                        .slice(0, 5)
                        .join("-")
                        .replace(/-+/g, "-");
                      props.history.push(`/${generatedSlug}/${item?.news_id}`);
                    }
                  }}
                />
                {index % 6 === 0 && index !== 0 && (
                  <div className="home_all_advertiesment mt-2 mb-2">
                    {/* <NewsHomeBottomAdd /> */}
                    <HomePageCenterAdd />
                  </div>
                )}
              </React.Fragment>
            );
          })}

        {isLoading && <NewsCard data={{ type: "loading", isBorder: true }} />}
        {hasMore && (
          <div className="loading-more">
            {/* Loading more news... */}
            <Button
              data={{
                btnName: loadingMore ? "Loading..." : "Load More News",
                buttonType: "primary ",
                buttonSize: "xs",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (!loadingMore && hasMore) {
                  setLoadingMore(true);
                  await loadMoreNews(pageNo);
                }
              }}
            />
          </div>
        )}
        {!hasMore && (
          <div className="loading-more">No more news available.</div>
        )}
      </NewsGroup>
    </>
  );
};
export default withRouter(Index);
// export default Index;
